export default "__VITE_ASSET__C8KDg0U0__"